<template>
  <iModal
    v-model="visible"
    title="关注供需"
    :z-index="1010"
    @on-cancel="close"
    class-name="collect-modal myModel"
    width="858"
  >
    <div class="ranking2">
      <Scroll :on-reach-bottom="handleReachBottom" height="600" v-if="rankingData && rankingData.length > 0">
        <Row class="ranking2-wrap">
          <div class="rc" v-for="(item,index) in rankingData" :key="index">
            <Col span="12">
              <div class="rc-row" @click="goDetails(item)">
                <div class="rc-row-box">
                  <div class="rc-item">
                    <div class="rc-img-box">
                      <img v-if="item.banner[0]" :src="item.banner[0]" class="s-square"/>
                      <img v-else src="@assets/img/empty.png" />
                    </div>
                    <div class="rc-test">
                      <p class="rc-test-title" :title="item.title">{{item.title}} <span>发布的供需</span></p>
                      <p class="rc-test-comN">{{item.information}}</p>
                    </div>
                    <div class="rc-item-collect">
                      <Icon type="md-star" @click.native.stop="calCollect(item)"/>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </div>
        </Row>
      </Scroll>
      <div v-else class="empty">暂无数据</div>
    </div>
    <div slot="footer">
      <Button type="primary" @click="cancel">确认</Button>
    </div>
  </iModal>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "collect",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      rankingData: [],
      PageSize: 30,
      PageIndex: 1,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      exhibiton: "loginModule/getExhibition"
    }),
  },
  watch: {
    show(val, oldVal) {
      this.visible = val;
      if (val) {
        this.init();
      }
    }
  },
  methods: {
    ...mapMutations({
      setChanceCollectId: "setChanceCollectId"
    }),
    ...mapActions({
      delCollect: "hall/delCollect",
    }),
    init() {
      const reqBody = {
        By: this.user.userId,
        PageSize: this.PageSize,
        PageIndex: this.PageIndex,
      };
      this.$http
        .post("/api/ReleaseFollower/GetByUserId", reqBody,this.$store.state.header)
        .then(doc => {
          let state = doc.data;
          if (doc.status === 200 && state.items) {
            state.items.map(c => {
                if (c.banner && c.banner.length) {
                    let arr = JSON.parse(c.banner);
                    c.banner = arr;
                } else {
                    c.banner = [];
                }
                return c;
            });
            this.rankingData = state.items;
            console.log(this.rankingData,'doc')
          }
        });
    },
    handleReachBottom() {
      var that = this;
      this.PageIndex += 1;
      return new Promise(resolve => {
        const reqBody = {
          By: this.user.userId,
          PageSize: this.PageSize,
          PageIndex: this.PageIndex,
        };
        this.$http
          .post("/api/ReleaseFollower/GetByUserId", reqBody, this.$store.state.header)
          .then(doc => {
            let state = doc.data;
            if (doc.status === 200 && state.items) {
              state.items.map(c => {
                if (c.banner && c.banner.length) {
                    let arr = JSON.parse(c.banner);
                    c.banner = arr;
                } else {
                    c.banner = [];
                }
                return c;
              });
              that.rankingData = [...that.rankingData, ...state.items];
              console.log(that.rankingData);
              resolve();
            }
          });
      });
    },
    ok() {
      this.visible = false;
    },
    cancel() {
      this.close();
    },
    close() {
      this.PageIndex = 1;
      this.$emit("close", false);
    },
    calCollect(item) {
      const opt = {
        userId: this.user.userId,
        releaseId: item.releaseId,
      }
        this.$http.put(`/api/ReleaseFollower/UnFollow`, opt,this.$store.state.header)
                .then(res=>{
                  if(res.status === 200 && res.data.successed){
                    this.$Message.success("取消成功");
                    this.setChanceCollectId(item.releaseId);
                    this.init();
                  }else{
                    this.$Message.error("取消失败，请重新尝试");
                  }
                })
    },
    goDetails(item) {
      this.$emit("close",false);
      this.$router.push(`/chance-detail?chanceId=${item.releaseId}`);
    }
  }
};
</script>

<style lang="scss">
.collect-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal{
    top: 0;
  }
  .ivu-modal-body {
    padding: 0;
  }
}
</style>
<style lang="scss" scoped>
.ranking2 {
  width: 100%;
  background: #fff;
  box-sizing: border-box;
  border-radius: 0 0 5px 5px;
  &-wrap {
    padding: 10px;
  }
  .rc {
    .rc-row {
      border: 1px solid #f0f0f0;
      margin: 0 10px 20px 10px;
      border-radius: 5px;

      .rc-img-box {
        position: relative;
        width: 96px;
        height: 96px;
        box-sizing: border-box;
        margin-left: 4px;
        display: inline-block;
        flex-shrink: 0;
        img {
          width: 96px;
          height: 96px;
          display: inline-block;
          border-radius: 50%;
          border: 1px solid #eaeaea;
        }
        .s-square{
            border-radius: 5px;
        }
      }

      .rc-test {
        width: calc(100% - 108px);
        margin-left: 10px;
        flex-direction: column;
        margin-bottom: 5px;
        margin-top: 5px;

        &-title {
          font-weight: 600;
          color: #333;
          font-size: 16px;
          width: 224px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin: 0;
          span {
            font-size: 14px;
            color: #666;
          }
        }
        &-comN {
            font-size: 14px;
            color:#4d4d4d;
            width: 224px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
        }

        &-main {
          display: flex;
          align-items: center;
          font-size: 12px;
          // margin:4px 0;
          color: #666;
          &__txt {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 224px;
          }
          .rc-border {
            font-size: 14px;
            color: #4c4c4c;
            border-radius: 2px;
            margin-right: 5px;
            padding: 1px 3px 1px 0;
            line-height: 1.5;
            // border: 1px solid #e6e6e6;
            // display: flex;
            // align-items: center;
            .icon {
              font-size: 16px;
              position: relative;
              left: -2px;
            }
            span {
              position: relative;
              left: -5px;
              // display: inline-block;
              // max-width: 195px;
            }
          }

          &.z-padd {
            margin: 2px 0 6px 0;
            font-size: 14px;
            color: #999;
            i {
              font-size: 16px;
            }
          }

          .brand {
            line-height: 1.2;
            margin-right: 8px;
            span {
              color: #999;
              line-height: 18px;
              display: flex;
              align-items: center;
            }
          }
        }
      }
    }

    .rc-row-box {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      cursor: pointer;
      padding: 10px;
      height: 118px;
    }
  }

  .rc-item {
    display: flex;
    width: 100%;
    min-height: 70px;
    padding-right: 20px;
    position: relative;
    &-line {
      width: 100%;
      min-height: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #1890ff;
      span {
        // border: 1px solid #e6e6e6;
        padding: 1px 2px;
        border-radius: 2px;
      }
    }
  }
  .rc-item-collect {
    position: absolute;
    right: 0;
    color: #fc791a;
    font-size: 18px;
    top:2px;
  }
}

.brand .iconfont {
  font-size: 13px;
  display: inline-block;
  margin-right: 2px;
}

.brand span .icon-guanzhu {
  position: relative;
  top: -1px;
}

.brand span .icon-dianzan,
.brand span.icon-guanzhu {
  font-size: 12px;
}

.brand span .icon-zhiboguankanshu {
  position: relative;
  top: 1px;
}

.ranking2 .rc .rc-item-right {
  margin-left: 38px;
}

.ranking2 .rc-item-bottom {
  border-radius: 2px;
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 0px 8px 0px rgba(149, 152, 155, 0.3);
  position: relative;
  z-index: 3;
  padding: 10px;
  box-sizing: border-box;
}

.ranking2 .rc-item-bottom:before {
  content: "";
  width: 10px;
  height: 10px;
  background-color: #fff;
  box-shadow: 0px 0px 8px 0px rgba(149, 152, 155, 0.3);
  transform: rotate(45deg);
  position: absolute;
  top: -5px;
  left: 20px;
  z-index: -1;
}

.ranking2 .rc-item-bottom:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #fff;
  z-index: 1;
  border-radius: 2px;
}

.ranking2 .rc .rc-item-right .rc-item-blist {
  font-size: 0;
  display: flex;
  position: relative;
  left: 1%;
  z-index: 2;
}

.ranking2 .rc .rc-item-right .rc-item-blist_one {
  width: 33.333333%;
  padding-right: 2%;
  cursor: pointer;
}

.ranking2 .rc .rc-item-right .rc-item-blist_imgbox {
  width: 100%;
  position: relative;
  height: 0;
  overflow: hidden;
  padding-bottom: 66.666667%;
}

.ranking2 .rc .rc-item-right .rc-item-blist_imgbox img {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.empty {
  line-height: 500px;
  color: #ccc;
  text-align: center;
}
.rank_reading{
  margin: 5px 0;
  font-size: 14px;
  line-height: 14px;
  color: #999;
}
</style>